

import { Component, Vue } from 'vue-property-decorator';
import { RemoteFeatureFlagsModule } from '~/store/modules/remoteFeatureFlags';

@Component
export default class FeatureFlags extends Vue {
    selectedFlag: string | null = null;
    async mounted() {
        await RemoteFeatureFlagsModule.getAvailableFlags();
    }
    get availableFeatureFlags() {
        return RemoteFeatureFlagsModule.availableFlags.filter((flag) =>
            !RemoteFeatureFlagsModule.currentUserFlagIds.includes(flag.id),
        );
    }
    async addUserFlag(flagId: string) {
        await RemoteFeatureFlagsModule.addFlagToUser(flagId);
        this.selectedFlag = null;
    }
}
